'use client';

import ErrorPage from '@eliadmin/core/src/pages/error';

export default ErrorPage;
